"use strict";

exports.__esModule = true;
exports.CssDataTypeEnum = void 0;
var _schema = require("@wix/component-protocol/schema");
exports.DISPLAY_GROUPS = _schema.DISPLAY_GROUPS;
exports.LAYOUT = _schema.LAYOUT;
let CssDataTypeEnum = exports.CssDataTypeEnum = /*#__PURE__*/function (CssDataTypeEnum) {
  CssDataTypeEnum["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
  CssDataTypeEnum["number"] = "number";
  CssDataTypeEnum["string"] = "string";
  CssDataTypeEnum["angle"] = "angle";
  CssDataTypeEnum["color"] = "color";
  CssDataTypeEnum["length"] = "length";
  CssDataTypeEnum["percentage"] = "percentage";
  CssDataTypeEnum["lengthPercentage"] = "lengthPercentage";
  CssDataTypeEnum["blendMode"] = "blendMode";
  CssDataTypeEnum["customEnum"] = "customEnum";
  CssDataTypeEnum["time"] = "time";
  return CssDataTypeEnum;
}({});
//# sourceMappingURL=types.js.map